export const blockSymbolsHashLessThanGreaterThanDoublePause = /^(?![-#<>]{2})(?!.*[-#<>]{2})(?!.*[-#<>]{2}$)(?!\s)[-\w\s.@/\\ąćężźłóńś]*[\wąćężźłóńś]$/;